export default () => {
  const pageTransitionOverlay = document.querySelector(
    "#page-transition-overlay",
  )
  const animationDuration = 200

  if (pageTransitionOverlay) {
    pageTransitionOverlay.classList.remove("skip-transition")

    setTimeout(function () {
      pageTransitionOverlay.classList.remove("active")
    }, 0)

    setTimeout(() => {
      // Prevent the theme editor from seeing this
      pageTransitionOverlay.classList.remove("active")
    }, animationDuration)

    document.body.addEventListener("click", (event) => {
      const target = event.target

      // Only want links...
      if (
        target.tagName !== "A" ||
        !target.getAttribute("href") ||
        target.getAttribute("target") === "_blank" ||
        target.classList.contains("no-transition")
      ) {
        return
      }

      const href = target.getAttribute("href")

      // That aren't anchors or mailto/tel links
      if (
        href[0] === "#" ||
        href.indexOf("mailto:") === 0 ||
        href.indexOf("tel:") === 0
      ) {
        return
      }

      onClickedToLeave(event, target)
    })

    window.onpageshow = function (e) {
      if (e.persisted) {
        pageTransitionOverlay.classList.remove("active")
      }
    }
  }

  function onClickedToLeave(event, target) {
    // avoid interupting open-in-new-tab click
    if (event.ctrlKey || event.metaKey) return

    event.preventDefault()

    // Hint to browser to prerender destination
    const linkHint = document.createElement("link")
    linkHint.setAttribute("rel", "prerender")
    linkHint.setAttribute("href", target.href)

    document.head.appendChild(linkHint)

    setTimeout(() => {
      window.location.href = target.href
    }, animationDuration)

    pageTransitionOverlay.classList.add("active")
  }
}
